import PageLayout from "@/components/feature/PageLayout";
import { Link } from "react-router-dom";

export default function AutoRenewPage() {
  return (
    <PageLayout>
      <div className="bg-white rounded-2xl border border-gray-200 p-8">
        <div className="mb-1">
          <span className="text-xs font-bold uppercase tracking-widest text-gray-400">Subscription Management</span>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">Does my subscription automatically renew?</h2>
        <div className="space-y-4 text-sm">
          <p className="text-gray-500">
            Yes, subscriptions renew automatically at the end of each billing cycle unless you cancel before the renewal date.
          </p>
          <h4 className="font-semibold text-gray-800">How automatic renewal works:</h4>
          <ul className="list-disc list-inside space-y-2 text-gray-500">
            <li>Your subscription renews on the same date each month (or year, depending on your plan)</li>
            <li>You will be charged the same amount as your original subscription</li>
            <li>A receipt will be sent to your registered email address</li>
            <li>You can cancel at any time before the renewal date to avoid being charged</li>
          </ul>
          <h4 className="font-semibold text-gray-800">How to stop automatic renewal:</h4>
          <p className="text-gray-500">
            To prevent your subscription from renewing, contact our support team at least 24 hours before your next billing date. We will cancel the renewal and confirm via email.
          </p>
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <p className="text-sm text-gray-500">
              <strong className="text-gray-700">Tip:</strong> Check your original sign-up email for your billing date, or contact us and we&apos;ll look it up for you.
            </p>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col sm:flex-row gap-3">
          <Link to="/contact-support" className="inline-block bg-[#2d2f36] text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-center">
            Contact Support
          </Link>
          <Link to="/subscription/cancelling" className="inline-block border border-gray-200 text-gray-700 px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer text-center">
            How to Cancel
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
